export const OBJECT_TYPE = {
  CONTACT: '0-1',
  COMPANY: '0-2',
  DEAL: '0-3',
  TICKET: '0-5',
  BLOG_POST: '0-39',
  CONTENT: '0-10',
  LANDING_PAGE: '0-25',
  FORM: '0-28',
  MARKETING_EMAIL: '0-29',
  AD_CAMPAIGN: '0-31',
  AD_GROUP: '0-32',
  CAMPAIGN: '0-35',
  SITE_PAGE: '0-38',
  CTA: '0-42',
  WORKFLOW: '0-44',
  OBJECT_LIST: '0-45',
  MEETING_EVENT: '0-47',
  PUBLISHING_TASK: '0-50',
  MARKETING_EVENT: '0-54',
  SOCIAL_BROADCAST: '0-71',
  /** @deprecated prefer WEB_INTERACTIVE as it matches the canonical object type name */
  WEB_INTERACTIVES: '0-91',
  WEB_INTERACTIVE: '0-91',
  MARKETING_SMS: '0-124',
  AUTOMATION_PLATFORM_FLOW_ACTION: '0-143',
  AUTOMATION_JOURNEY: '0-158',
  WHATSAPP: '0-830',
  CALL: '0-48',
  AUTOMATION_PLATFORM_FLOW: '0-44',
  CASE_STUDY: '0-161',
  KNOWLEDGE_ARTICLE: '0-151',
  PODCAST_EPISODE: '0-163',
  FILE_MANAGER_FILE: '0-77',
  FEEDBACK_SURVEY: '0-111',
  SALES_DOCUMENT: '0-83',
  PLAYBOOK: '0-96',
  SEQUENCE: '0-58',
  /** @deprecated use MEDIA_BRIDGE, which matches the BE object definition name */
  Media: '0-57',
  MEDIA_BRIDGE: '0-57',
  EMAIL: '0-49',
  EXTERNAL_WEB_URL: '0-138',
  SCHEDULING_PAGE: '0-121',
  SOCIAL_POST: '0-37',
  AI_SEARCH_PROMPT: '0-1468',
  AI_SEARCH_CITATION: '0-1466',
  AI_SEARCH_TOPIC: '0-1467'
};